import { PortalErrorNotice } from '@/components/common/portal-error-notice';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@/components/ui/skeleton';
import { usePortalSession } from '../api/use-portal';

export function RequirePortalAuth({ children }: { readonly children: ReactNode }): JSX.Element {
  const session = usePortalSession();
  const { t } = useTranslation();
  if (session.isPending)
    return (
      <div className="min-h-dvh space-y-4 p-6" aria-busy="true">
        <Skeleton className="h-10 w-56" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  if (session.isError)
    return (
      <div className="space-y-4 p-6">
        <PortalErrorNotice error={session.error} />
        <Link className="text-primary underline" to="/portal/login">
          {t('portal.backToLogin')}
        </Link>
      </div>
    );
  return <>{children}</>;
}
